// extracted by mini-css-extract-plugin
module.exports = {"title":"ResourceHeader__title___sjWMs type__headingLarge___r2V7Z","subtitle":"ResourceHeader__subtitle___-jGsS","errorList":"ResourceHeader__errorList___Kk7TK"};